const CONTACT = {
  ES: {
    phone: '+34 91 143 60 83',
  },
  FR: {
    phone: '+33 1 75 85 03 29',
  },
  NL: {
    phone: '+31 020 80 04 979',
  },
};

export default CONTACT;
export const getContactInfoByCountry = (country) => CONTACT[country] || {};
